import { render, staticRenderFns } from "./SparkChart.vue?vue&type=template&id=b2992734&scoped=true&"
import script from "./SparkChart.vue?vue&type=script&lang=js&"
export * from "./SparkChart.vue?vue&type=script&lang=js&"
import style0 from "./SparkChart.vue?vue&type=style&index=0&id=b2992734&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2992734",
  null
  
)

export default component.exports